import axios from "@/services/axios";

export default async  function getPricingList(){
    const response:any =await axios(`/pricing/`, 'GET')
    return response?.contents?.map((item: any) => ({
        label: item?.name,
        value: item?.id,
        data: item
    }))


}